<template>
  <div>
    <b-row class="justify-content-start">
      <b-col md="2" class="w-100" v-if="type == 'BULK'">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-col>
    </b-row>
    <b-row class="mb-3 justify-content-start">
      <!-- Left section filtre -->
      <b-col v-if="!flagBPCE && !flagTOOLBOX" cols="12" lg="8" xl="6" class="mt-2 text-xl-start">
        <b-button-group class="mt-3 mt-sm-0" style="display:grid;grid-auto-flow:column;" v-if="type !== 'BULK'">
          <b-button :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('tracking.DDV') }}</b-button>
          <b-button :variant="tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('tracking.DDD') }}</b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row class="mb-6 justify-content-end">
      <!-- Left section filtre -->
      <b-col cols="4" lg="2" xl="2" class="mt-2">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ tabName === 1 && flagCACP ? $t('filter.additional_filter'): $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2" class="mt-2" v-if="flagTOOLBOX">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2" class="mt-2" v-else>
        <b-button class="btnFilter"
          @click="refreshInbox()"
          :disabled="dateBegin == ''">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <hr  class="mx-auto"/>
    <b-row>
      <!--Filtre Résultat de la correspondance -->


      <!--Filtre Case Summary -->
      <b-col sm="6" lg="2"  class="filter-item"  v-if="tabName === 1 && displayFilter && flagTOOLBOX">
        <input-filter-dropdown-list
            @update-val="updateVal"
            :reset-trigger="resetSignal"
            :label="$t('toolbox.filtre_case_summary')"
            :item-list="AllRowName"
            trad-path="toolbox.view_request_summary_case"
        ></input-filter-dropdown-list>
      </b-col>
<!--      <b-col sm="6" lg="3" cols="12" class="filter-item mb-4"  v-if="tabName === 1 && displayFilter && flagTOOLBOX">-->
<!--        <label class="filter-item-title" for="filter-bic_from_regex">{{ $t('tracking.testcase_name') }}</label>-->
<!--        <span class="filter-item-content">-->
<!--          <input v-model="TestCaseName"-->
<!--                 id="filter-bic_from_regex"-->
<!--                 type="text"-->
<!--                 :class="{'filter-item-input': true, 'filter-item-input-complete': TestCaseName}"-->
<!--                 :placeholder="$t('tracking.testcase_name')"-->
<!--                 style="width: 100%">-->
<!--        </span>-->
<!--      </b-col>-->

      <!--Filtre Résultat de la correspondance -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-4"  v-if="tabName === 1 && displayFilter && flagTOOLBOX">
        <label class="filter-item-title" for="filter-result">{{ $t('tracking.testcase_status') }}</label>
        <select class="form-control mw-100" v-model="TestCaseStatus" id="filter-result">
          <option value="" disabled selected>{{ $t('tracking.select_testcase_status') }}</option>
          <option
            v-for="result in TestCaseStatusOptions"
            :key="'test-case-status-' + result.id"
            :value="result.id">
            {{ result.text }}
          </option>
        </select>
      </b-col>

      <!--Filtre Résultat de la correspondance -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-4"  v-if="tabName === 1 && displayFilter">
        <label class="filter-item-title" for="filter-result">{{ $t('tracking.maching_result') }}</label>
        <select class="form-control mw-100" v-model="Result" id="filter-result">
          <option value="" disabled selected>{{ $t('tracking.select_result') }}</option>
          <option
            v-for="result in resultMatchingOptions"
            :key="result.id"
            :value="result.id">
            {{ result.text }}
          </option>
        </select>
      </b-col>

      <!--Filtre Statut de la demande -->
      <b-col v-if="displayFilter" sm="6" lg="3" cols="12" class="filter-item mb-4">
        <label class="filter-item-title" for="filter-techstatuscode">{{ $t('tracking.technical_code') }}</label>
        <select class="form-control mw-100" v-model="TechStatusCode" id="filter-techstatuscode">
          <option value="" disabled selected>{{ $t('tracking.select_status') }}</option>
          <option
            v-for="status in techStatusOptions"
            :key="status.id"
            :value="status.id">
            {{ status.text }}
          </option>
        </select>
      </b-col>
    </b-row>
    <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-start" >
      <!-- Filtre date de début -->
      <b-col v-if="tabName === 1 || (tabName === 2 && displayFilter)" sm="3" class="filter-item ">
        <datetime-picker-custom format="YYYY-MM-DD HH:mm:ss" periodFull
          id="filter-datebegin-rq1"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
          :inputLabel="!flagCACP ? $t('common.date_start_label_rq1') : tabName === 1 ? $t('common.date_start_label_rq1_cacp') : $t('tracking.creation_date_start_request_1_ddd_filter')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          :is-mandatory="flagCACP && tabName === 1"
          v-model="dateBegin">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin -->
      <b-col v-if="tabName === 1 || (tabName === 2 && displayFilter)"  sm="3" class="filter-item ">
        <datetime-picker-custom format="YYYY-MM-DD HH:mm:ss" periodFull
          id="filter-dateend-rq1"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
          :inputLabel="!flagCACP ? $t('common.date_end_label_rq1') : tabName === 1 ? $t('common.date_end_label_rq1_cacp'):$t('tracking.creation_date_end_request_1_ddd_filter')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEnd">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de début Rq2-->
      <b-col v-if="flagCACP && displayFilter" sm="6" lg="3" cols="12" class="filter-item ">
        <datetime-picker-custom format="DD/MM/YYYY HH:mm:ss" periodFull
          id="filter-datebegin-rq2"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginRq2}"
          :inputLabel="tabName === 1 ? $t('common.date_start_label_rq2'): $t('tracking.creation_date_start_request_2_ddd_filter')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBeginRq2">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin Rq2-->
      <b-col v-if="flagCACP && displayFilter" sm="6" lg="3" cols="12" class="filter-item ">
        <datetime-picker-custom format="DD/MM/YYYY H:i:s"
          id="filter-dateend-rq2"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndRq2}"
          :inputLabel="tabName === 1 ? $t('common.date_end_label_rq2'): $t('tracking.creation_date_end_request_2_ddd_filter')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEndRq2">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de début Rp1-->
      <b-col v-if="flagCACP && displayFilter && tabName == 1" sm="6" lg="3" cols="12" class="filter-item ">
        <datetime-picker-custom format="DD/MM/YYYY H:i:s"
          id="filter-datebegin-rp1"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginRp1}"
          :inputLabel="$t('common.date_start_label_rp1')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBeginRp1">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin Rp1-->
      <b-col v-if="flagCACP && displayFilter && tabName == 1" sm="6" lg="3" cols="12" class="filter-item ">
        <datetime-picker-custom  format="DD/MM/YYYY H:i:s"
          id="filter-dateend-rp1"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndRp1}"
          :inputLabel="$t('common.date_end_label_rp1')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEndRp1">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de début Rp2-->
      <b-col v-if="flagCACP && displayFilter" sm="6" lg="3" cols="12" class="filter-item ">
        <datetime-picker-custom  format="DD/MM/YYYY H:i:s"
          id="filter-datebegin-rp2"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginRp2}"
          :inputLabel="tabName === 1 ? $t('common.date_start_label_rp2'): $t('tracking.creation_date_start_response_2_ddd_filter')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBeginRp2">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin Rp2-->
      <b-col v-if="flagCACP && displayFilter" sm="6" lg="3" cols="12" class="filter-item ">
        <datetime-picker-custom  format="DD/MM/YYYY H:i:s"
          id="filter-dateend-rp2"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndRp2}"
          :inputLabel="tabName === 1 ? $t('common.date_end_label_rp2'): $t('tracking.creation_date_end_response_2_ddd_filter')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEndRp2">
        </datetime-picker-custom>
      </b-col>

      <!--Filtre BIC -->
<!--      <b-col v-if="displayFilter" sm="6" lg="3" cols="12" class="filter-item ">-->
<!--        <label class="filter-item-title" for="filter-bic">{{ $t('tracking.bic') }}</label>-->
<!--        <span class="filter-item-content">-->
<!--          <input v-model.trim="BIC"-->
<!--            id="filter-bic"-->
<!--            type="text"-->
<!--            :class="{'filter-item-input': true, 'filter-item-input-complete': BIC}"-->
<!--            :placeholder="$t('tracking.bic')"-->
<!--            style="width: 100%">-->
<!--        </span>-->
<!--      </b-col>-->

<!--      Filtre BIC From-->
      <b-col v-if="displayFilter && (tabName == 2 && flagCACP)" sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-bic-from">{{ $t('tracking.bic_from') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="BICFrom"
            id="filter-bic-from"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': BICFrom}"
            :placeholder="$t('tracking.bic_from')"
            style="width: 100%">
        </span>
      </b-col>

<!--      Filtre BIC To-->
      <b-col v-if="displayFilter && (tabName == 2 && flagCACP)" sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-bic-to">{{ $t('tracking.bic_to') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="BICTo"
            id="filter-bic-to"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': BICTo}"
            :placeholder="$t('tracking.bic_to')"
            style="width: 100%">
        </span>
      </b-col>

      <!--Filtre IBAN -->
      <b-col v-if="displayFilter  && (tabName == 2 && !flagCACP)" sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-iban">{{ $t('tracking.iban') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="IBAN"
            id="filter-iban"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': IBAN}"
            :placeholder="$t('tracking.iban')"
            style="width: 100%">
        </span>
      </b-col>

      <!--Filtre Country -->
      <b-col v-if="flagCACP && tabName === 1 && displayFilter" sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-countrycode">{{ $t('tracking.country_code') }}</label>
        <select class="form-control mw-100" v-model="CountryCode" id="filter-countrycode">
          <option value="" disabled selected>{{ $t('tracking.select_country') }}</option>
          <option
            v-for="country in countries"
            :key="country"
            :value="country">
            {{ $t('countriesAlpha2Code.'+country) }}
          </option>
        </select>
      </b-col>

      <!--Filtre Message ID -->
      <b-col v-if="flagCACP && tabName === 1 && displayFilter"  sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-message_id">{{ $t('tracking.message_id') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="MessageId"
                 id="filter-message_id"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': MessageId}"
                 :placeholder="$t('tracking.message_id')"
                 style="width: 100%">
        </span>
      </b-col>

      <!--Filtre BICFromRegex -->
      <b-col v-if="flagCACP && tabName === 1 && displayFilter"  sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-bic_from_regex">{{ $t('tracking.bic_from_regex') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="BICFromRegex"
                 id="filter-bic_from_regex"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': BICFromRegex}"
                 :placeholder="$t('tracking.bic_from_regex')"
                 style="width: 100%">
        </span>
      </b-col>

      <!--Filtre BICToRegex -->
      <b-col v-if="flagCACP && tabName === 1 && displayFilter"  sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-bic_to_regex">{{ $t('tracking.bic_to_regex') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="BICToRegex"
                 id="filter-bic_to_regex"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': BICToRegex}"
                 :placeholder="$t('tracking.bic_to_regex')"
                 style="width: 100%">
        </span>
      </b-col>

      <!--Filtre VopProvider -->
      <!-- <b-col v-if="flagCACP && displayFilter"  sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-vop-provider">{{ $t('tracking.vop_provider') }}</label>
        <select class="form-control mw-100" v-model="VopProvider" id="filter-vop-provider">
          <option value="" disabled selected>{{ $t('tracking.select_vop_provider') }}</option>
          <option value="1">STET</option>
          <option value="2">EBA</option>
        </select>
      </b-col> -->

      <!--Filtre VopProvider -->
      <b-col v-if="flagCACP && displayFilter"  sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-vop-provider">{{ $t('tracking.vop_provider') }}</label>
        <select class="form-control mw-100" v-model="VopProvider" id="filter-vop-provider">
          <option value="" disabled selected>{{ $t('tracking.select_vop_provider') }}</option>
          <option v-for="vopProvider in vopProviderList" :key="vopProvider.id" :value="vopProvider.id">
            {{ vopProvider.text }}
          </option>
        </select>
      </b-col>

      <!-- Filtre BIC From Onus-->
      <b-col v-if="flagCACP && tabName === 1 && displayFilter" sm="6" lg="3" cols="12" class="filter-item ">

        <label class="filter-item-title" for="filter-bic">{{ $t('tracking.bic_from_onus') }}</label>
        <div class="item-input">
          <label class="label-switch">
            <input type="checkbox" class="checkService" @change="BICFromOnus = !BICFromOnus" :checked="BICFromOnus" v-bind:value="BICFromOnus">
            <div class="checkbox"></div>
          </label>
        </div>
      </b-col>

      <b-col v-if="flagTOOLBOX && tabName === 1 && displayFilter"  sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-reference">{{ $t('tracking.reference') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="Reference"
                 id="filter-reference"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': Reference}"
                 :placeholder="$t('tracking.reference')"
                 style="width: 100%">
        </span>
      </b-col>

      <!-- Filtre BIC To Onus-->
      <b-col v-if="flagCACP && tabName === 1 && displayFilter" sm="6" lg="3" cols="12" class="filter-item ">
        <label class="filter-item-title" for="filter-bic">{{ $t('tracking.bic_to_onus') }}</label>
        <div class="item-input">
          <label class="label-switch">
            <input type="checkbox" class="checkService" @change="BICToOnus = !BICToOnus" :checked="BICToOnus" v-bind:value="BICToOnus">
            <div class="checkbox"></div>
          </label>
        </div>
      </b-col>

      <b-col cols="3">
        <b-col class="d-flex justify-content-end align-items-center mt-4 px-0">
          <b-button class="mr-3" size="sm"
                    @click="clearFilterFields"
                    :disabled="!hasInputFilter">
            {{ $t('injection_tab.reset') }}
          </b-button>
          <b-button size="sm"
                    :disabled="tabName !== 2 && (dateBegin == '' && !flagTOOLBOX)"
                    @click="applyFilter()">
            {{ $t('common.srch') }}
          </b-button>
        </b-col>
      </b-col>
    </b-row>
<!--    <b-row class="min-w-100 justify-content-end  mr-1" v-if="(tabName === 1 && displayFilter) || (tabName === 2 && displayFilter)">-->
<!--      &lt;!&ndash; Bouton Effacer et Appliquer &ndash;&gt;-->

<!--    </b-row>-->
    <div class="d-flex justify-content-end" v-if="TracksList.length > 0 && !flagTOOLBOX">
      <b-button class="btnFilter_2 mx-3"
        @click="extractCSV()"
        disabled>
        <i class="fa-light fa-upload fs-14px"></i>
        <span class="fab-label">{{ $t('common.extract_page') }}</span>
      </b-button>
    </div>

    <hr  class="mx-auto mb-4" v-if="displayFilter"/>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="TracksList.length > 0" style="overflow:auto">
      <b-table hover :key="resetTable"
        class="table table-striped"
        style="margin-bottom:0"
        :fields="fields"
        :items="TracksList"
        :selectable="TracksList.length > 0"
        :empty-text="$t('common.security.no_result')"
        @row-clicked="seeTracksDetails">
        <template #cell(CreationDateRq1)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(Request1CreationDate)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(Request2CreationDate)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(Response2CreationDate)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(CreationDateRp2)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(NameScore)="data">
          <span>{{ data.value ? getResultText(data.value) : data.item.IdScore ? getResultText(data.item.IdScore) : '-' }}</span>
        </template>
        <template #cell(BICFrom)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(TestCaseName)="data">
          <span>{{ getTestCaseName(data.value) }}</span>
        </template>
        <template #cell(TestCaseStatus)="data">
          <i v-if="data.value === '2'" title="OK" class="fas fa-check bg-success text-white"
             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
          </i>
          <i v-else-if="data.value === '0'" title="KO" class="fas fa-times bg-danger text-white"
             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
          </i>
          <i v-else-if="data.value === '4'" title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
          <i v-else-if="data.value === '3'" title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
          <i v-else-if="data.value === '5'" title="Not tested yet" class="fas fa-minus bg-secondary text-white"
             style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
          </i>
          <p v-else>{{ data.value }}</p>
        </template>
        <template #cell(BICOnUs)="data">
          <span>
              <i v-if="data.value == 1" class="fa-regular fa-circle-check cursor color-var-actionButtonColorBlue" ></i>
              <i v-if="data.value == 0" class="fa-regular fa-circle-xmark cursor text-danger" ></i>
          </span>
        </template>
        <template #cell(BICTo)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(Country)="data">
          <span>{{ getCountry(data.item.CountryCode) }}</span>
        </template>
        <template #cell(IBAN)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(Status)="data">
          <span>{{ data.value }}</span>
        </template>
        <template #cell(Name)="data">
          <span v-if="data.item.FullName !== ''">{{ data.item.FullName }}</span>
          <span v-else> - </span>
        </template>
        <template v-if="tabName === 2 && !flagBPCE" #cell(Type)="data">
          <i v-if="data.item.Type === '2'" class="fa-solid fa-building"></i>
          <i v-else-if="data.item.Type === '1'" class="fa-solid fa-user"></i>
          <span v-else> - </span>
        </template>
        <template #cell(TestedData)="data">
          <span v-if="data.item.FullName !== ''">{{ data.item.FullName }}</span>
          <span v-else-if="data.item.Siren !== ''">{{ data.item.Siren }}</span>
          <span v-else-if="data.item.Siret !== ''">{{ data.item.Siret }}</span>
          <span v-else-if="data.item.TVAIntracomm !== ''">{{ data.item.TVAIntracomm }}</span>
          <span v-else-if="data.item.LEI !== ''">{{ data.item.LEI }}</span>
          <span v-else-if="data.item.EUID !== ''">{{ data.item.EUID }}</span>
          <span v-else> - </span>
        </template>
        <template #cell(Result)="data">
          <span v-if="data.item.IdScore !== ''">
            <span
              class="result-vignette"
              :class="{
                'result-mtch': data.item.IdScore === 'MTCH',
                'result-nmtc': data.item.IdScore === 'NMTC',
                'result-cmtc': data.item.IdScore === 'CMTC',
                'result-noap': data.item.IdScore === 'NOAP',
              }"
            ></span>
            {{ getResultText(data.item.IdScore) }}
          </span>
          <span v-else-if="data.item.NameScore !== ''">
            <span
              class="result-vignette"
              :class="{
                'result-mtch': data.item.NameScore === 'MTCH',
                'result-nmtc': data.item.NameScore === 'NMTC',
                'result-cmtc': data.item.NameScore === 'CMTC',
                'result-noap': data.item.NameScore === 'NOAP',
              }"
            ></span>
            {{ getResultText(data.item.NameScore) }}
          </span>
          <span v-else> - </span>
        </template>
        <template #cell(TechStatusCode)="data">
          <span v-if="data.item.TechStatusCode !== ''">{{ translateTechStatusCode(data.item.TechStatusCode) }}</span>
          <span v-else>{{ $t('common.monitoring.success') }} </span>
        </template>
        <template #cell(Provider)="data">
          <span>{{ data.value == 1 ? 'STET':'EBA' }}</span>
        </template>
        <template #cell(ResponseDuration)="data">
          <span>{{ getDuration(data.item) }}</span>
        </template>
        <template #cell()="data">
          <span>{{ data.value ? data.value : '-' }}</span>
        </template>
      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult" v-if="flagCACP && tabName === 1">
          {{ isMandatoryFieldMiss ? $t('common.missing_required_field') : $t('common.no_result') }}
      </span>
      <span class="noResult" v-else>
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import conf from '../../config/config.dev.js'
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download"
import BackButton from "@/components/common/backButton.vue"
import alpha2Country from "../../data/alpha2Country.json"
import inputFilterDropDownList from "@/pages/toolbox/InputFilterDropDownList.vue";


export default {
  name: 'TrackingPage',
  components: {
    'input-filter-dropdown-list': inputFilterDropDownList,
    BackButton,
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    fields () {
      let fields
      if (this.tabName === 1) {
        if (this.flagCACP) {
          fields = [
            { key: 'MsgId', label: this.$i18n.t('tracking.message_id'), class: 'text-center', sortable: false },
            { key: 'Request1CreationDate', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
            { key: 'Request2CreationDate', label: this.$i18n.t('tracking.creation_date_request_2'), class: 'text-center', sortable: false },
            { key: 'Response2CreationDate', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_1'), class: 'text-center', sortable: false },
            { key: 'BICOnUs', label: this.$i18n.t('tracking.bic_onus'), class: 'text-center', sortable: false },
            { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
            // { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            // { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
            // { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
            { key: 'ReasonCode', label: this.$i18n.t('tracking.reason_code'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
            { key: 'ResponseDuration', label: this.$i18n.t('common.response_time'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
          ]
        } else if (this.flagTOOLBOX) {
          fields = [
            // { key: 'Reference', label: this.$i18n.t('tracking.reference'), class: 'text-center', sortable: false },
            { key: 'Request1CreationDate', label: this.$i18n.t('common.dt'), class: 'text-center', sortable: false },
            { key: 'TestCaseName', label: this.$i18n.t('tracking.testcase_name'), class: 'text-center', sortable: false },
            { key: 'TestCaseStatus', label: this.$i18n.t('tracking.testcase_status'), class: 'text-center', sortable: false },
            { key: 'NameScore', label: this.$i18n.t('tracking.name_score'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
          ]
        } else {
          fields = [
            { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), thClass: 'min-w-160px', class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
            { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
            { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
            { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
          ]
        }
      } else {
        if (this.flagCACP){
          fields = [
            { key: 'MsgId', label: this.$i18n.t('tracking.message_id_ddd'), class: 'text-center', sortable: false },
            { key: 'Provider', label: this.$i18n.t('tracking.provider_ddd'), class: 'text-center', sortable: false },
            { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from_ddd'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to_ddd'), class: 'text-center', sortable: false },
            { key: 'Request1CreationDate', label: this.$i18n.t('tracking.creation_date_request_1_ddd'), class: 'text-center', sortable: false },
            { key: 'Request2CreationDate', label: this.$i18n.t('tracking.creation_date_request_2_ddd'), class: 'text-center', sortable: false },
            { key: 'Response2CreationDate', label: this.$i18n.t('tracking.creation_date_response_1_ddd'), class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2_ddd'), class: 'text-center', sortable: false },
            // { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            // { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
            { key: 'ResponseDuration', label: this.$i18n.t('tracking.response_time_ddd'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code_ddd'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: false },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            // { key: 'Type', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: false },

          ]
        }
        else{
          fields = [
            { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), thClass: 'min-w-160px', class: 'text-center', sortable: false },
            { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
            { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
            { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
            { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
            { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
            { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
            // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: false },
            // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
            // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
            { key: 'Type', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: false },
          ]
        }

      }

      return fields
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.IBAN ||
          this.BIC ||
          this.BICFrom ||
          this.BICTo ||
          this.dateBegin ||
          this.dateEnd ||
          this.dateBeginRq2 ||
          this.dateEndRq2 ||
          this.dateBeginRp2 ||
          this.dateEndRp2 ||
          this.dateBeginRp1 ||
          this.dateEndRp1 ||
          this.TechStatusCode ||
          this.CountryCode ||
          this.MessageId ||
          this.Result ||
          this.Reference ||
          this.TestCaseName ||
          this.TestCaseStatus !== '') {
        return true
      }
      return false
    },
  },
  data () {
    return {
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      identifier: '',
      TechStatusCode: '',
      CountryCode: '',
      MessageId: '',
      BICFromRegex: '',
      BICToRegex: '',
      Reference: '',
      VopProvider: '',
      Result: '',
      BIC: '',
      BICFrom: '',
      BICTo: '',
      IBAN: '',
      tabName: 1,
      countries: alpha2Country.countries.reverse(),
      flagCACP: conf.visual === 'CACP',
      flagBPCE: conf.visual === 'BPCE',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      BICToOnus: false,
      BICFromOnus: false,
      MessageId: '',
      dateBegin: '',
      dateBeginRq2: '',
      dateEndRq2: '',
      dateBeginRp2: '',
      dateEndRp2: '',
      dateBeginRp1: '',
      dateEndRp1: '',
      returnUrl: '',
      dateEnd: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      resetTable: false,
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      resetSignal: 0,
      AllRowName: [],
      TestCaseName: '',
      TestCaseStatus: '',
      trackActive: '',
      TracksList: [],
      resultMatchingOptions: [
        { id: "NOAP", text: "Not Applicable" },
        { id: "MTCH", text: "Match" },
        { id: "NMTC", text: "No Match" },
        { id: "CMTC", text: "Close Match" },
        { id: "NULL", text: this.$t('tracking.no_result') }
      ],
      TestCaseStatusOptions: [
        { id: "0", text: this.$t('tracking.testcase_status_list.0') },
        { id: "1", text: this.$t('tracking.testcase_status_list.1') },
        { id: "2", text: this.$t('tracking.testcase_status_list.2') },
        { id: "3", text: this.$t('tracking.testcase_status_list.3') },
        { id: "4", text: this.$t('tracking.testcase_status_list.4') }
      ],
      techStatusOptions: [
        {id: "NULL", text: this.$t("common.monitoring.success") },
        {id: "KO", text: this.$t("common.monitoring.unsuccess") }
      ],
      vopProviderList: []
    }
  },
  created () {
    if(this.flagBPCE){
      this.tabName = 1
    }else{
      if (this.type === 'DDV' || this.type === 'BULK') {
        this.tabName = 1
      } else{
        this.tabName = 2
      }
    }
    if (this.type === 'BULK') {
      this.defineReturnURL()
    }
    // this.$bus.$emit('switch-selected-menu', '/tracking/')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    if (!this.flagCACP){
      this.onRefresh(false)
    }
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    if (this.$engine.rights.rightIs('vopProvider_consult', true)) {
      this.getVopProvider()
    }
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.tracking.cleanFilterCondition()
  },
  methods: {
    updateVal(newVal) {
      this.TestCaseName = newVal
    },
    defineReturnURL () {
      let that = this
      this.returnUrl = '/trackingbulk/' + this.id
    },
    applyFilter (filterConditions = {}) {
      if(this.tabName !== 2 && this.dateBegin === '' && !this.flagTOOLBOX){
        this.isMandatoryFieldMiss = false
        return
      }
      this.isMandatoryFieldMiss = false
      this.TracksList = []
      let that = this
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.tracking.cleanFilterCondition()

      // for (let propertyCustom in filterConditions) {
      //   this.$engine.tracking[propertyCustom] = filterConditions[propertyCustom]
      // }
      // filterConditions = this.$engine.tracking.getConditionObject()

      // this.$emit('applyFilter', actualFilter.getConditionObject())

      // if (this.id !== 'NULL') {
      //   filterConditions.IdBulk = this.id
      // }
      filterConditions.BIC = this.BIC.trim()
      filterConditions.BICFrom = this.BICFrom.trim()
      filterConditions.BICTo = this.BICTo.trim()
      filterConditions.IBAN = this.IBAN.trim()
      filterConditions.TechStatusCode = this.TechStatusCode
      filterConditions.CountryCode = this.CountryCode
      filterConditions.MessageId = this.MessageId
      filterConditions.BICFromRegex = this.BICFromRegex
      filterConditions.BICToRegex = this.BICToRegex
      filterConditions.Reference = this.Reference
      filterConditions.VopProvider = this.VopProvider
      filterConditions.Result = this.Result
      filterConditions.TestCaseName = this.TestCaseName
      filterConditions.TestCaseStatus = this.TestCaseStatus
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin).utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd).utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateBeginRq2 = this.dateBeginRq2 != '' ? moment(this.dateBeginRq2 , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEndRq2 = this.dateEndRq2 != '' ? moment(this.dateEndRq2 , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateBeginRp2 = this.dateBeginRp2 != '' ? moment(this.dateBeginRp2 , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEndRp2 = this.dateEndRp2 != '' ? moment(this.dateEndRp2 , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateBeginRp1 = this.dateBeginRp1 != '' ? moment(this.dateBeginRp1 , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEndRp1 = this.dateEndRp1 != '' ? moment(this.dateEndRp1 , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.BICFromOnus = this.BICFromOnus != false ? '1' : ''
      filterConditions.BICToOnus = this.BICToOnus != false ? '1' : ''
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex
      filterConditions.Type = this.tabName === 1 ? 'DDV' : 'DDD'

      this.$engine.tracking.getTracks(
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalTracks
        that.paginationObject.nbResults = resp.data.tracks.length
        resp.data.tracks.forEach(item => {
          item.company_name = item.company_name
          item.statusVerification = item.statusVerification
          item.active = item.active
        })
        requests = resp.data.tracks
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getCountry(countryCode) {

      if (!this.countries.includes(countryCode)) {
        return this.$t('countriesAlpha2Code.UNKNOWN')
      }

      return this.$t(`countriesAlpha2Code.${countryCode}`) || this.$t('countriesAlpha2Code.UNKNOWN')
    },
    getTestCaseName (name) {
      if (this.$i18n.t('toolbox.req_summary_case.' + name) !== 'toolbox.req_summary_case.' + name) {
        return this.$i18n.t('toolbox.req_summary_case.' + name)
      } else if (this.$i18n.t('toolbox.resp_summary_case.' + name) !== 'toolbox.resp_summary_case.' + name) {
        return this.$i18n.t('toolbox.resp_summary_case.' + name)
      }
      return name ? name : '-'
    },
    getTestCaseStatus (status) {
      return this.$t('tracking.testcase_status_list.' + status) !== 'tracking.testcase_status_list.' ? this.$t('tracking.testcase_status_list.' + status) : '-'
    },
    getResultText (id) {
      const option = this.resultMatchingOptions.find(opt => opt.id === id)
      return option ? option.text : '-'
    },
    getVopProvider () {
      let params = {}
      let that = this
      this.$engine.vopProvider.getVopProvider(params).then((resp) => {
        this.vopProviderList = resp.data.VopProvider.map(vopProvider => ({
          id: vopProvider.IdVopProvider,
          text: vopProvider.NameVopProvider,
          value: vopProvider.NameVopProvider
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.IBAN = ''
      this.BIC = ''
      this.BICFrom = ''
      this.BICTo = ''
      this.dateEnd = ''
      this.dateBegin = ''
      this.dateBeginRq2 = ''
      this.dateEndRq2 = ''
      this.dateBeginRp2 = ''
      this.dateEndRp2 = ''
      this.BICFromOnus = false
      this.BICToOnus = false
      this.CountryCode = ''
      this.MessageId = ''
      this.BICFromRegex = ''
      this.BICToRegex = ''
      this.Reference = ''
      this.VopProvider = ''
      this.dateBeginRp1 = ''
      this.dateEndRp1 = ''
      this.TechStatusCode = ''
      this.TestCaseName = ''
      this.TestCaseStatus = ''
      this.Result = ''
      this.resetSignal++
      this.communicateChange()
      this.TracksList = []
      if (!this.flagCACP || this.tabName == 2){
        this.applyFilter()
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        Type: this.tabName === 1 ? 'DDV' : 'DDD',
        BIC: this.BIC.trim(),
        BICFrom: this.BICFrom.trim(),
        BICTo: this.BICTo.trim(),
        IBAN: this.IBAN.trim(),
        TechStatusCode: this.TechStatusCode,
        CountryCode: this.CountryCode,
        MessageId: this.MessageId,
        BICFromRegex: this.BICFromRegex,
        BICToRegex: this.BICToRegex,
        Reference: this.Reference,
        VopProvider: this.VopProvider,
        Result: this.Result,
        TestCaseName: this.TestCaseName,
        dateBegin: this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateBeginRq2: this.dateBeginRq2 != '' ? moment(this.dateBeginRq2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEndRq2: this.dateEndRq2 != '' ? moment(this.dateEndRq2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateBeginRp2: this.dateBeginRp2 != '' ? moment(this.dateBeginRp2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEndRp2: this.dateEndRp2 != '' ? moment(this.dateEndRp2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateBeginRp1: this.dateBeginRp1 != '' ? moment(this.dateBeginRp1, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEndRp1: this.dateEndRp1 != '' ? moment(this.dateEndRp1, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        BICFromOnus: this.BICFromOnus != false ? '1' : '',
        BICToOnus: this.BICToOnus != false ? '1' : '',
      }
      // if (this.id !== 'NULL') {
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.tracking.getTracks(
        filterConditions
      ).then(resp => {
        this.AllRowName = []
        this.TracksList = []

        if(resp.data.AllTestCaseNameResp){
          let result = []
          if(!Array.isArray(resp.data.AllTestCaseNameResp))
            result.push(resp.data.AllTestCaseNameResp)
          else {
            result = resp.data.AllTestCaseNameResp
          }
          result.forEach(rowName => {
            this.AllRowName.push(rowName["~Unknown_2"])
          })
        }
        if(resp.data.AllTestCaseNameReq){
          let result = []
          if(!Array.isArray(resp.data.AllTestCaseNameReq))
            result.push(resp.data.AllTestCaseNameReq)
          else {
            result = resp.data.AllTestCaseNameReq
          }
          result.forEach(rowName => {
            this.AllRowName.push(rowName["~Unknown_2"])
          })
        }

        let requests = {}
        if (resp.data && resp.data.tracks.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotalTracks
          that.paginationObject.nbResults = resp.data.tracks.length
          requests = resp.data.tracks
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    extractCSV (){
      let utcOffsetMinutes = moment().utcOffset()
      let utcOffsetHours = utcOffsetMinutes / 60
      let that = this
      this.pageCounter = 0
      // this.paginationObject['firstIndex'] = 1
      // this.paginationObject['nbResultsTotal'] = 0

      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        Type: this.tabName === 1 ? 'DDV' : 'DDD',
        extract : 1,
        OffsetUTC: (utcOffsetHours >= 0 ? '+' : '')+ utcOffsetHours,
        BIC: this.BIC.trim(),
        BICFrom: this.BICFrom.trim(),
        BICTo: this.BICTo.trim(),
        IBAN: this.IBAN.trim(),
        TechStatusCode: this.TechStatusCode,
        CountryCode: this.CountryCode,
        MessageId: this.MessageId,
        BICFromRegex: this.BICFromRegex,
        BICToRegex: this.BICToRegex,
        Reference: this.Reference,
        VopProvider: this.VopProvider,
        Result: this.Result,
        dateBegin: this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateBeginRq2: this.dateBeginRq2 != '' ? moment(this.dateBeginRq2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEndRq2: this.dateEndRq2 != '' ? moment(this.dateEndRq2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateBeginRp2: this.dateBeginRp2 != '' ? moment(this.dateBeginRp2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEndRp2: this.dateEndRp2 != '' ? moment(this.dateEndRp2, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateBeginRp1: this.dateBeginRp1 != '' ? moment(this.dateBeginRp1, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        dateEndRp1: this.dateEndRp1 != '' ? moment(this.dateEndRp1, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : '',
        BICFromOnus: this.BICFromOnus != false ? '1' : '',
        BICToOnus: this.BICToOnus != false ? '1' : ''
      }

      // if (this.id !== 'NULL') {
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.tracking.getTracks(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()

        const binaryString = window.atob(resp.data)
        const len = binaryString.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }

        const csvData = new TextDecoder('utf-8').decode(bytes)

        const rows = csvData.split('\n').map(row => row.split(';'))
        const headers = rows[0].map(header => header.replace(/\"/g, '').trim())
        const dataIndex = headers.indexOf('RequestStatus')

        const modifiedRows = rows.map((row, index) => {
          if (index === 0) return row
          if (row[dataIndex] && dataIndex !== -1) {
            row[dataIndex] = that.translateTechStatusCode(row[dataIndex])
          } else{
            row[dataIndex] = that.$t('common.monitoring.success')
          }
          return row
        })

        const modifiedCsv = "\ufeff" + modifiedRows.map(row => row.join(';')).join('\n')

        const linkSource = 'data:text/csv;charset=utf-8,' + encodeURIComponent(modifiedCsv)
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = this.$t('Webheader.tracking') + '_' + today.unix() + '.csv'

        if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }

        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    changeTabName (tabName) {
      this.TracksList = []
      this.tabName = tabName
      this.clearFilterFields()
      if (!this.flagCACP || tabName === 2){
        this.onRefresh()
      }
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      let type = that.tabName === 1 ? 'DDV':'DDD'
      if (this.type === 'BULK') {
        type = this.id
      }
      this.resetTable = !this.resetTable
      loadPage(that, {url: '/trackingdetails/' + type +'/' + id})
    },
    reOrderBy (column) {
      this.TracksList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      // if (this.id !== 'NULL'){
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.tracking.getTracks(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalTracks
        that.paginationObject.nbResults = resp.data.tracks.length
        resp.data.tracks.forEach(item => {
          item.statusVerification = item.statusVerification
          item.company_name = item.company_name
          item.active = item.active
        })
        requests = resp.data.tracks
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    translateTechStatusCode (code) {
      if (this.$t('tracking.error-status.' + code) !== 'tracking.error-status.' + code) {
        return this.$t('tracking.error-status.' + code)
      } else {
        return this.$t('tracking.error-status.default', { statusCode: code })
      }

    },
    updateInbox (requests, noAttach = false) {
      this.TracksList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeTracksDetails (items) {
      this.activateDetail(items.IdTrack)
    },
    getDate (date) {
      if (date !== '') {
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss.SSS')
      }
      else {
        return '-'
      }
    },
    getDuration (item) {
      if (item.Request1CreationDate !== '' && item.Request2CreationDate !== '' && item.Response2CreationDate !== '' && item.CreationDateRp2 !== '') {
        const start = moment(item.Request1CreationDate)
        const end = moment(item.CreationDateRp2)

        return end.diff(start, 'milliseconds') + ' ms'
      }
      else {
        return '-'
      }
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
